import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { injectIntl } from "react-intl";
import ACTIONS from "../../actions/types";

// REDUX
import { useDispatch } from "react-redux";
import { formatDateTime } from "../../vendors/calTimeZone";

// COMPONENTS
import Layout from "../layout/Layout";
import Icon from "../icons/Icon";

// FUNCTIONS
import getDateAndTime from "../../functions/getDateAndTime";

// HOOKS
import useTimer from "../../hooks/useTimer";

const StageCounter = ({ data, hide, callback, intl }) => {
  const dispatch = useDispatch();
  const [timer, setDayTime] = useTimer();
  const [isVisible, setIsVisible] = useState(true);
  const [timeIn, setTimeIn] = useState();
  const [status, setTheStatus] = useState();
  const userRole = useSelector(store => store.user.role_selected);

  // for testing ////////////////////////
  // var today = "Thu Nov 20 2020 19:38:19 GMT+0100 (Central European Standard Time)";
  // data.active = true;

  const dateInfo = getDateAndTime({
    date: data.end_at, // data.end_at
  }); //data.start_at, data.end_at, new Date().setSeconds(new Date().getSeconds() + 10)

  useEffect(() => {}, []);

  useEffect(() => {
    init(data);
  }, [data]);

  useEffect(() => {
    if (timer && timer.counterDone) {
      if (callback) callback();
      setTheStatus("expired");
    }
  }, [timer]);

  const init = data => {
    // if end_at is null hide the counter
    if (!data.end_at || hide) {
      setIsVisible(false);
    }

    // if active
    else if (data.active) {
      // check if in days
      if (dateInfo.timeLeft.in === "days" && timeIn !== "days") {
        setTimeIn("days");
      } else if (dateInfo.timeLeft.in === "hours" && timeIn !== "hours") {
        setTimeIn("hours");
      }

      setDayTime(data.end_at);
      setTheStatus("active");
    }

    // if expired
    if (!data.active) {
      setTheStatus("expired");
    }

    // if it starts in the future
    else if (!data.active) {
    }
  };

  const formatNumber = num => (!isNaN(num) && String(num).length === 1 ? "0" + num : String(num));

  const renderTime = intl => {
    if (status === "expired") {
      return (
        <Layout flex1 flex justifyContentCenter alignItemsCenter>
          <Icon iconId="clockLine" addClass="__a_i c4" />
          {userRole === "reviewer" && (
            <span
              dangerouslySetInnerHTML={{
                __html: intl.formatMessage({ id: "stageExpired" }),
              }}
            />
          )}
        </Layout>
      );
    } else if (status === "active") {
      const reviewDeadlineLabel = intl.formatMessage({ id: "reviewDeadline" }); // "Bis zum Bewertungsschluss"

      const days = timer?.days ?? 0;
      const hours = timer?.hours ?? 0;
      const minutes = timer?.minutes ?? 0;
      const seconds = timer?.seconds ?? 0;

      const isUnderOneHour = days === 0 && hours <= 1;
      const isUnderOneHourStyle = isUnderOneHour ? { color: "red" } : undefined;

      const endAt = timer?.input
        ? new Date(timer.input)
        : data?.end_at
        ? new Date(data.end_at)
        : null;

      const dateStr = endAt ? formatDateTime(endAt, "DD.MM.YYYY - HH:mm") : "";

      return (
        <Layout flex1 flex justifyContentCenter alignItemsCenter>
          <Icon iconId="clockLine" addClass="__a_i c1" />
          {timer?.input && (
            <span style={{ textAlign: "left", display: "inline-block" }}>
              <div style={{ fontWeight: 600, fontSize: "1em" }}>
                {days > 0 ? (
                  <>
                    {days} {intl.formatMessage({ id: days === 1 ? "day" : "days" })}
                  </>
                ) : (
                  <span style={isUnderOneHourStyle}>
                    {formatNumber(hours)}:{formatNumber(minutes)}:{formatNumber(seconds)}
                  </span>
                )}
                <span style={{ fontWeight: 300, fontSize: "0.7em" }}>{reviewDeadlineLabel}</span>
              </div>
              <div style={{ fontSize: "0.6em" }}>{dateStr}</div>
            </span>
          )}
        </Layout>
      );
    }
  };

  if (!isVisible) return null;
  return (
    <div className="bc12 br3 __a">
      <Layout flex spaceBetween>
        {renderTime(intl)}
      </Layout>
    </div>
  );
};

export default injectIntl(StageCounter);
